export const getLastString = (str: string) => str.substr(str.lastIndexOf('/') + 1);

export const getRelativeUrl = (fullUrl: string) => `/${fullUrl.replace(/^(?:\/\/|[^/]+)*\//, '')}`;

export const addDepartmentsPathPrefix = (path: string) =>
  `/departments${path.replace('/departments', '')}`;

export const removeDepartmentsPathPrefix = (path: string) =>
  path && path.replace('/departments', '');
